import profilePic2 from './../assets/images/logo.png'
import profilePic3 from './../assets/images/logo.png'
import profilePic1 from './../assets/images/logo.png'
import profilePic4 from './../assets/images/logo.png'
import profilePic5 from './../assets/images/logo.png'
import profilePic6 from './../assets/images/logo.png'
import profilePic7 from './../assets/images/logo.png'
import profilePic8 from './../assets/images/logo.png'

const carouselData = [
  {
    id: '1',
    img: profilePic1,
    text: '1 text text text text text text'
  },
  {
    id: '2',
    img: profilePic2,
    text: '2 text text text text text text'
  },
  {
    id: '3',
    img: profilePic3,
    text: '3 text text text text text text'
  },
  {
    id: '4',
    img: profilePic4,
    text: '4 text text text text text text'
  },
  {
    id: '5',
    img: profilePic5,
    text: '5 text text text text text text'
  },
  {
    id: '6',
    img: profilePic6,
    text: '6 text text text text text text'
  },
  {
    id: '7',
    img: profilePic7,
    text: '7 text text text text text text'
  },
  {
    id: '8',
    img: profilePic8,
    text: '8 text text text text text text'
  },
  {
    id: '9',
    img: profilePic1,
    text: '9 text text text text text text'
  },
  {
    id: '10',
    img: profilePic2,
    text: '10 text text text text text text'
  },
  {
    id: '11',
    img: profilePic3,
    text: '11 text text text text text text'
  },
  {
    id: '12',
    img: profilePic4,
    text: '12 text text text text text text'
  }
]

export default carouselData



// WEBPACK FOOTER //
// ./src/mocked-data/carouselData.js